import usdt from '../images/tokens/USDT.png';
import btally from '../images/tokens/btally.png';
import bnb from '../images/tokens/bnb.png';
import busd from '../images/tokens/busd.svg';
import wEth from '../images/tokens/wETH.png';
import aave from '../images/tokens/AAVE.jfif';
import link from '../images/tokens/LINK.png';
import xrp from '../images/tokens/XRP.png';
import dai from '../images/tokens/DAI.png';
import wbnb from '../images/tokens/WBNB.png';
import usdc from '../images/tokens/USDC.png';
import btcb from '../images/tokens/BTCB.jfif';
import eth from '../images/tokens/ETH.png';
import doge from '../images/tokens/doge.svg';

export const topPools = [
    {
        id: 1,
        firstToken: 'USDT',
        firstTokenIcon: usdt,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x8b3b2a5c69043c3076836165a2f4a9b328401141'
    },
    {
        id: 2,
        firstToken: 'bnb',
        firstTokenIcon: bnb,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x246da9b7533193f315226eb5abaa159e3d76d218'

    },
    {
        id: 3,
        firstToken: 'BUSD',
        firstTokenIcon: busd,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xdbc1ab7c92653304a3b98b2de149c18f128c3bd5'

    },
    {
        id: 4,
        firstToken: 'wETH',
        firstTokenIcon: wEth,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xb1e0ff09cd56a132684ae72a12c8b5b22f065f6c'

    },
    {
        id: 5,
        firstToken: 'AAVE',
        firstTokenIcon: aave,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x60ef42859e68b79555fa32763941d3c8122204ed'

    },
    {
        id: 6,
        firstToken: 'LINK',
        firstTokenIcon: link,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x4c824176fc6b7fc54ea5dac4828a3b9967d94807'

    },
    {
        id: 7,
        firstToken: 'XRP',
        firstTokenIcon: xrp,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xe490751838ec2db530ae7138a36a72ecf89455d6'

    },
    {
        id: 8,
        firstToken: 'DAI',
        firstTokenIcon: dai,
        secondToken: 'Tally',
        secondTokenIcon: btally,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x3d87b9def6addf57bb1503b1aefd07fc5aa05741'
    },
    {
        id: 9,
        firstToken: 'busd',
        firstTokenIcon: busd,
        secondToken: 'dai',
        secondTokenIcon: dai,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xd8b8b804c81e3082b4857920a53ae36db8c752f2'
    },
    {
        id: 10,
        firstToken: 'busd',
        firstTokenIcon: busd,
        secondToken: 'bnb',
        secondTokenIcon: bnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xc260c5f36f87e7402c4a4a91e2143e0541802739'
    },
    {
        id: 11,
        firstToken: 'busd',
        firstTokenIcon: busd,
        secondToken: 'WBNB',
        secondTokenIcon: wbnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xe80997dc0832b9707b4c6f1a865742c1cb648c79'
    },
    {
        id: 12,
        firstToken: 'USDT',
        firstTokenIcon: usdt,
        secondToken: 'BUSD',
        secondTokenIcon: busd,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x48494b8aedc52ce7016cb9a7d3812569b7cd26d5'
    },
    {
        id: 13,
        firstToken: 'USDT',
        firstTokenIcon: usdt,
        secondToken: 'dai',
        secondTokenIcon: dai,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x6db17abee60c4c8167a0ffdc84411c36109a39c3'
    },
    {
        id: 14,
        firstToken: 'usdt',
        firstTokenIcon: usdt,
        secondToken: 'USDC',
        secondTokenIcon: usdc,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xe59d396af7de4023ba913b1078bea9973c76baeb'
    },
    {
        id: 15,
        firstToken: 'usdt',
        firstTokenIcon: usdt,
        secondToken: 'BNB',
        secondTokenIcon: bnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xd962210c047373789420c72055427ea198e857bd'
    },
    {
        id: 16,
        firstToken: 'usdt',
        firstTokenIcon: usdt,
        secondToken: 'BTCB',
        secondTokenIcon: btcb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xc002a458ba51d7b75bcf9913029651dd7a88e459'
    },
    {
        id: 17,
        firstToken: 'usdt',
        firstTokenIcon: usdt,
        secondToken: 'ETH',
        secondTokenIcon: eth,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x9448c1d5a8c59d1c7a38b80bf67bb5f58861f8bd'
    },
    {
        id: 18,
        firstToken: 'eth',
        firstTokenIcon: eth,
        secondToken: 'WBNB',
        secondTokenIcon: wbnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x617389a96b401bcb7fb2decad4197b7792e16797'
    },
    {
        id: 19,
        firstToken: 'eth',
        firstTokenIcon: eth,
        secondToken: 'BTCB',
        secondTokenIcon: btcb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xaf075968c2dd4ed47dff8493a2ed0bcc4d3ef96c'
    },
    {
        id: 20,
        firstToken: 'BNB',
        firstTokenIcon: bnb,
        secondToken: 'BTCB',
        secondTokenIcon: btcb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x4c71c6ec7c5597d4281ac50a69a31eebef382b19'
    },
    {
        id: 21,
        firstToken: 'BNB',
        firstTokenIcon: bnb,
        secondToken: 'WBNB',
        secondTokenIcon: wbnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x0bf737c101a6e9d7609281059e6ebbe9703e883d'
    },
    {
        id: 22,
        firstToken: 'xrp',
        firstTokenIcon: xrp,
        secondToken: 'WBNB',
        secondTokenIcon: wbnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0x63f8595325e309764c1f415064ecf79135503e13'
    },
    {
        id: 23,
        firstToken: 'DOGE',
        firstTokenIcon: doge,
        secondToken: 'WBNB',
        secondTokenIcon: wbnb,
        volume24h: 57220000,
        volume7d: 878542000,
        lpRewardFees: 284546,
        lpRewardAPR: 33.5,
        liquidity: 27000210,
        hash: '0xfdfae64cd7095253a1611e77ef73493ee0bd9b59'
    }
]